/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Add_To_Company_PlaceholderInputs */

const en_admin_user_detail_add_to_company_placeholder = /** @type {(inputs: Admin_User_Detail_Add_To_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to a company…`)
};

const de_admin_user_detail_add_to_company_placeholder = /** @type {(inputs: Admin_User_Detail_Add_To_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu einem Unternehmen hinzufügen…`)
};

/**
* | output |
* | --- |
* | "Add to a company…" |
*
* @param {Admin_User_Detail_Add_To_Company_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_add_to_company_placeholder = /** @type {((inputs?: Admin_User_Detail_Add_To_Company_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Add_To_Company_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_add_to_company_placeholder(inputs)
	return en_admin_user_detail_add_to_company_placeholder(inputs)
});